// @flow
import * as firebase from 'firebase/app';
import "firebase/auth";
import environmentLoader from '../utils/environmentLoader';

const config = environmentLoader.load('config');
if(!config) {
    throw new Error('Config is undefined');
}

firebase.initializeApp({
    apiKey: config.firebase.apiKey,
    authDomain: config.firebase.authDomain,
    projectId: config.firebase.projectId
});

export default firebase;